import { l } from '@manychat/manyui'

import { KeywordRuleConditionTypes } from 'apps/growthTools/growthToolsInterfaces'
import { ConditionTypes } from 'apps/keywords/models/KeywordRule/constants'

export const DEFAULT_KEYWORD_RULE_CONDITION: KeywordRuleConditionTypes = ConditionTypes.EQUALS

export const MAX_KEYWORDS_PER_RULE = 12
export const MAX_KEYWORD_RULES = 5

export const KeywordRuleConditionOptions: Array<{
  label: () => string
  value: KeywordRuleConditionTypes
}> = [
  {
    label: l.makeTranslate('is exactly this'),
    value: ConditionTypes.EQUALS,
  },
  {
    label: l.makeTranslate('contains'),
    value: ConditionTypes.CONTAINS,
  },
  {
    label: l.makeTranslate('has the standalone word(s)'),
    value: ConditionTypes.WORD_MATCH,
  },
  {
    label: l.makeTranslate('begins with'),
    value: ConditionTypes.STARTS,
  },
  {
    label: l.makeTranslate('has any word except'),
    value: ConditionTypes.DOES_NOT_CONTAIN,
  },
]

export const getKeywordRuleConditionLabel = (condition: KeywordRuleConditionTypes): string => {
  const option = KeywordRuleConditionOptions.find((opt) => opt.value === condition)
  return l.getString(option?.label)
}
